__turbopack_context__.v({
  "accordion": "accordion-module-scss-module__GtnasG__accordion",
  "accordionDescription": "accordion-module-scss-module__GtnasG__accordionDescription",
  "accordionIcon": "accordion-module-scss-module__GtnasG__accordionIcon",
  "accordionTitle": "accordion-module-scss-module__GtnasG__accordionTitle",
  "hidden": "accordion-module-scss-module__GtnasG__hidden",
  "open": "accordion-module-scss-module__GtnasG__open",
});
